var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{staticStyle:{"height":"40vh"}}),_c('v-row',{attrs:{"justify":"center","align":"center"}},[_c('v-progress-linear',{attrs:{"color":"amber darken-3","indeterminate":"","rounded":"","height":"6"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }